import axios from 'axios'
import store from '../store/index'
export const baseURL = 'https://api.fleetperfection.com/api/v1'
const axiosInstance = axios.create({
  baseURL
})

axiosInstance.interceptors.request.use(function(config) {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `${token}`
  return config
})

axiosInstance.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    if (error.response.data.code === 401) {
      const { unauth } = store.state.layout
      if (unauth) return true
      store.commit('layout/SET_UN_AUTH', true)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
